export default [
  {
    name: 'FunnelsManagementList',
    path: 'settings/funnels-management',
    component: () => import('pages/settings/funnels-management/FunnelsManagementList.vue')
  },
  {
    name: 'FunnelsManagementCreate',
    path: 'settings/funnels-management/new',
    component: () => import('pages/settings/funnels-management/FunnelsManagementForm.vue')
  },
  {
    name: 'FunnelsManagementSingle',
    path: 'settings/funnels-management/:id',
    component: () => import('pages/settings/funnels-management/FunnelsManagementSingle.vue')
  },
  {
    name: 'FunnelsManagementEdit',
    path: 'settings/funnels-management/:id/edit',
    component: () => import('pages/settings/funnels-management/FunnelsManagementForm.vue')
  }
]
